<div [attr.class]="class" (click)="load()" [ngClass]="{'center': loading, 'cursor-pointer': enableClick}">
    <img *ngIf="!new && (picture || preview && !loading)" [src]="preview ? preview : picture + '?size=' + size" alt="Logo">

    <div *ngIf="new && (picture || preview && !loading)" [attr.class]="new" [style.backgroundImage]="'url(' + (preview ? preview : (picture + '?size=' + size)) + ')'"></div>

    <msc-common-spinner *ngIf="loading"></msc-common-spinner>
</div>

<input #upload class="display-none" type="file" accept="image/png,image/jpeg,image/jpg,image/gif" (change)="uploadPicture($event.target.files[0])">
